import { SxProps } from '@mui/material';

export const styles: Record<string, SxProps> = {
  popoverContainer: { borderRadius: '14px', boxShadow: 'rgba(0, 0, 0, 0.15)' },
  menuContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '16px',
  },
  optionContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '9px',
    cursor: 'pointer',
    textDecoration: 'none',
    bgcolor: 'transparent',
    border: 'none',
    padding: 0,
    margin: 0,
  },
};
